export const FirebaseConfig = {
	"projectId": "solarchauffeur-app",
	"appId": "1:345132841425:web:d402e851668169e703c8f0",
	"databaseURL": "https://solarchauffeur-app-default-rtdb.firebaseio.com",
	"storageBucket": "solarchauffeur-app.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyAGkrWW6F88zP1dHFVVwknfHv-o-NBal1U",
	"authDomain": "solarchauffeur-app.firebaseapp.com",
	"messagingSenderId": "345132841425",
	"measurementId": "G-9V8V8YVD9J"
};